import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function MembersHero() {
  return <section id="membershero" className="bg-background py-32 md:py-48 lg:py-56 flex items-center justify-center">
      <div className="container mx-auto px-4 text-center">
        <h1 className="font-default text-5xl md:text-6xl lg:text-7xl text-foreground tracking-tight mb-6">M / O Members Only</h1>
        
        <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed">
          Elevate your wellness journey with exclusive access to our premium IV therapy, vitamin injections, and self-care services. Experience the pinnacle of holistic health.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="rounded-full bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 px-8 h-14 text-base font-sans">
            <Link to="/MembershipsPage">Join Membership</Link>
          </Button>
          
          <Button asChild size="lg" className="rounded-full bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 px-8 h-14 text-base font-sans border-foreground/20">
            <Link to="/BookNowPage">Book Appointment</Link>
          </Button>
        </div>
      </div>
    </section>;
}